import { Select } from '@profgeosoft-ui/react';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import type { BasicParametersStore } from '../BasicParameters.store';

import styles from './selects.module.scss';

export const WellboresSelect = observer(function WellboresSelect({ store }: { store: BasicParametersStore }) {
  const { isWellboresLoading, wellboresOptions, currentWellbore, currentWell } = store;
  const [_, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (currentWellbore?.id) {
      setSearchParams((searchParams) => {
        searchParams.set('wellboreId', currentWellbore.id.toString());
        return searchParams;
      });
    } else {
      setSearchParams((searchParams) => {
        searchParams.delete('wellboreId');
        return searchParams;
      });
    }
  }, [currentWellbore?.id, setSearchParams, currentWellbore]);

  return (
    <Select
      loading={isWellboresLoading}
      options={wellboresOptions}
      disabled={!currentWell || isWellboresLoading}
      className={styles.wellboreSelect}
      sortOptions
      value={currentWellbore ? currentWellbore.name : null}
      onSelect={(value) => {
        store.setCurrentWellbore(value);
        setSearchParams((searchParams) => {
          searchParams.set('wellboreId', value);
          return searchParams;
        });
      }}
    />
  );
});
